module.exports = __webpack_public_path__ + "static/media/skeleton_9_16.aeaf1fef.png";